//
//
//
//
//
//
//
//
//
//

import betting from '~/plugins/betting'

export default {
  data() {
    return {
      systemBetSelection: null,
      systemBetChoices: [],
      loading: true
    }
  },
  watch: {
    selections: function (newVal, oldVal) {
      if (_.size(newVal) != _.size(oldVal)) {
        this.$store.commit('betslip/setError', null)
      }

      if (this.betType == 'system') {
        this.calculateSystemBets()
      }
    }
  },
  computed: {
    stakeSingle: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSingle
      },
      set(value) {
        this.$store.commit('betslip/setStakesBatch', value)
        this.$store.commit('betslip/setStakeSingle', value)
      }
    },
    stakeCombi: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeCombi
      },
      set(value) {
        this.$store.commit('betslip/setStakeCombi', value)
      }
    },
    stakeSystem: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSystem
      },
      set(value) {
        this.$store.commit('betslip/setStakeSystem', value)
      }
    },
    betType: {
      get() {
        return this.$store.state.betslip.betType
      },
      set(value) {
        this.$store.commit('betslip/setBetType', value)
      }
    },
    total_return() {
      console.log('total_return')
      let total = 0
      if (this.betType == 'single') {
        total = this.selections.reduce((accumulator, selection) => {
          let stake = parseFloat(_.get(this.$store.state.betslip, 'stakes.' + _.get(selection, 'outcome.id'), this.stakeSingle))
          console.log('stake', stake)
          if (_.isNaN(stake)) {
            stake = 0
          }
          return accumulator + parseFloat(_.get(selection, 'outcome.odds')) * stake
        }, 0)
      }
      if (this.betType == 'combi') {
        total = this.selections.reduce((accumulator, selection) => {
          return accumulator * parseFloat(_.get(selection, 'outcome.odds'))
        }, 1)
        total = total * this.stakeCombi
      }
      if (this.betType == 'system') {
        total = this.systemBetSelection.potential_return * this.total_stake
      }
      return total
    },
    total_stake() {
      let total = this.stake
      if (this.betType == 'single') {
        total = this.selections.reduce((accumulator, selection) => {
          let stake = parseFloat(_.get(this.$store.state.betslip, 'stakes.' + _.get(selection, 'outcome.id'), this.stake))
          if (_.isNaN(stake)) {
            stake = 0
          }
          return accumulator + stake
        }, 0)
      }
      if (this.betType == 'combi') {
        total = this.stakeCombi
      }
      if (this.betType == 'system') {
        total = this.systemBetSelection.combinations * this.stakeSystem
      }
      return total
    },
    total_bets() {
      if (this.betType == 'single') {
        return _.size(this.$store.state.betslip.selections)
      }
      if (this.betType == 'combi') {
        return 1
      }
      if (this.betType == 'system') {
        return this.systemBetSelection.combinations
      }
    },
    selections() {
      return this.$store.state.betslip.selections
    }
  },
  methods: {
    changeStake() {
      this.$store.commit('betslip/clearStakes')
    },
    async calculateSystemBets() {
      betting.setSelections(this.selections)
      this.systemBetChoices = betting.generateBetTypes()
      this.systemBetSelection = _.first(this.systemBetChoices)
    },
    async selectBetType(betType) {
      if (this.selections.length < 2 && betType == 'combi') {
        return
      }
      if (this.selections.length <= 2 && betType == 'system') {
        return
      }
      this.calculateSystemBets()
      this.betType = betType
    },
    async openSettings() {
      this.$modal.show('modal-settings')
    },
    async clear() {
      this.$store.commit('betslip/setProcessingStatus', false)
      this.$store.commit('betslip/clear')
      this.$store.commit('betslip/setError', null)
    },
    async close() {
      this.$store.commit('betslip/toggleBetslip', false)
    },
  }
}
